import Axios from 'Helpers/axios';

export default class UserController {
  async sendMail(form) {
    const axios = Axios.getInstance('/api');
    const res = await axios.post('/nodemail-criptonomia', form);

    return res.data;
  }
}
